import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Filter Variant Minus"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-filter-variant-minus',
    templateUrl: './icon-filter-variant-minus.component.html',
    styleUrls: ['./icon-filter-variant-minus.component.scss'],
    standalone: false
})
export class IconFilterVariantMinusComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
